import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-undo-component',
  imports: [],
  templateUrl: './icon-undo-component.html',
  styleUrl: './icon-undo-component.scss',
})
export class IconUndoComponent {
  @Input() tooltip?: string;
}
